import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateAssetCase($companyId: ID!, $id: ID!, $attributes: AssetCaseAttributes!) {
    updateAssetCase(companyId: $companyId, id: $id, attributes: $attributes) {
      assetCase {
        id
        ...UpdatedAssetCase
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedAssetCase on AssetCase {
    id
    description
    height
    length
    warehouse {
      id
    }
    weight
    width
  }
`
